// eslint-disable-next-line no-unused-vars
import React from 'react';
import { flushSync } from 'react-dom';
import { func } from 'prop-types';
import { withTranslation } from 'react-i18next';

import { API_PRODUCTS } from 'Constants';
import ProductPropType from 'Types/product';
import ProductTableItemComponent from 'Components/Products/ProductTableItem';
import ProductAbstract from 'Containers/ProductAbstract';
import withCart from 'AppSrc/hocs/withCart';
import withFetch from 'AppSrc/hocs/withFetch';
import withUser from 'AppSrc/hocs/withUser';
import withProducts from 'AppSrc/hocs/withProducts';
import withWishlist from 'AppSrc/hocs/withWishlist';
import withModals from 'AppSrc/hocs/withModals';
import withToastNotifications from 'AppSrc/hocs/withToastNotifications';

@withProducts
@withFetch
@withUser
@withCart
@withWishlist
@withModals
@withToastNotifications
@withTranslation()
export default class ProductTableItem extends ProductAbstract {
  constructor(props) {
    super(props);
    this.handleOnChangeQuantity = this.handleOnChangeQuantity.bind(this);
    this.handleOnToggle = this.handleOnToggle.bind(this);
    // initialize quantity as 0
    this.state.product.quantity = 0;
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      this.state.detailsViewOpen !== nextState.detailsViewOpen
      || this.state.detailsError !== nextState.detailsError
      || this.state.detailsLoading !== nextState.detailsLoading
      || super.shouldComponentUpdate(nextProps, nextState)
    );
  }

  handleOnChangeQuantity(qty) {
    const { product } = this.state;
    const { onChangeQty } = this.props;
    const newQty = Math.min(
      product.stockValue,
      Math.max(qty, qty === 0 ? 0 : product.minQuantity || 1)
    );
    if (newQty !== product.quantity) {
      const newProduct = {
        ...product,
        quantity: newQty
      };
      flushSync(() => {
        this.setState({
          product: newProduct
        });
      });
      if (typeof onChangeQty === 'function') {
        onChangeQty(newProduct);
      }
    }
  }

  /**
   * Toggle the dropdown
   * @returns {Promise<void>}
   */
  async handleOnToggle() {
    const { product, detailsViewOpen } = this.state;
    const { productsContext, fetch } = this.props;

    if ('groupAttributes' in product) {
      this.setState({ detailsViewOpen: !detailsViewOpen });
      return;
    }

    try {
      this.setState({
        detailsViewOpen: !detailsViewOpen,
        detailsError: null,
        detailsLoading: true
      });
      const data = await fetch(`${ API_PRODUCTS }/${ product.id }/table-view`);
      this.setState(prevState => ({
        ...prevState,
        product: {
          ...prevState.product,
          ...data
        }
      }), () => {
        const { product: updatedProduct } = this.state;
        productsContext.updateProduct({
          ...updatedProduct,
          quantity: updatedProduct.quantity,
          minQuantity: updatedProduct.minQuantity
        });
      });
    } catch (err) {
      this.setState({ detailsError: err.message });
    } finally {
      this.setState({ detailsLoading: false });
    }
  }

  render() {
    const { product, detailsViewOpen, detailsError, detailsLoading } = this.state;
    return (
      <ProductTableItemComponent
        product={ product }
        error={ detailsError }
        loading={ detailsLoading }
        open={ detailsViewOpen }
        handleOnToggle={ this.handleOnToggle }
        onStockAlertModalOpen={ this.handleStockAlertModalOpen }
        onAddToCart={ this.handleOnAddToCart }
        onChangeQuantity={ this.handleOnChangeQuantity }
      />
    );
  }
}

ProductTableItem.propTypes = {
  product: ProductPropType,
  onChangeQty: func,
};
